import { Pipe, PipeTransform } from '@angular/core';
import { PricePipe } from './price';

@Pipe({ name: 'tns' })
export class TnsPipe implements PipeTransform {
  private PRECISION = 3;

  constructor(private pricePipe: PricePipe) {}

  transform(value: any, arg?: string) {
    if (typeof value === 'string' || typeof value === 'number') {
      if (typeof value === 'string') {
        value = Number(value);
      }

      // Si el valor a parsear es mayor a 1 millón lo expresaremos en unidades de un millón.
      let addM = false;
      if (value >= 1000000) {
        value = value/1000000; 
        addM = true;
      }

      const tmp = this.pricePipe.transform(value, arg);
      const parts = tmp.split(',');
      const decimalLength = parts[1] ? parts[1].length : 0;
      if (decimalLength < this.PRECISION) {
        return parts[0] + ',' + (parts[1] || '') + Array(this.PRECISION - decimalLength).fill('0').join('') + (addM ? 'M' : '');
      } else {
        return parts[0] + ',' + (parts[1] || '').substr(0, this.PRECISION) + (addM ? 'M' : '');
      }
    }

	  return value;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/pipes/tns.ts